import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { CollapsibleHedge, Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { scroller } from 'react-scroll';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { modalActions, inputTilesActions } from '../../redux/root-action';
import { getDomain } from '../../utils/api';
import { analyticsTracking } from 'utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey900};
  padding-top: 32px;
`;

const StyledImage = styled.img`
  margin: 32px 0px 32px 0px;
`;

const informationAndAssumptionsText =
  'The chart assumes an annual salary of $50,000, which is not adjusted for inflation. It shows potential before-tax account balances in 20 years, assuming a 7% annual rate of return net of fees. Earnings are compounded biweekly and contributions are invested at the beginning of each pay period. This table is for illustrative purposes only and is not meant to represent any of the investment options in your plan. All investments involve risk, including possible loss of principal.';

let noOfActivePlans = 0,
  planNumber = 0,
  noOfNQPlans = 0,
  // eslint-disable-next-line
  showCTA = true,
  isRPStrac = false;

class IncreaseContribution extends Component<any, any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = {
      rpsTracStatus: false,
    };
  }

  componentDidMount = () => {
    const { accounts } = this.props;
    let rpsTerminatedCount = 0;

    for (let i = 0; i < accounts.length; i++) {
      // Checking for RPS TRAC
      if (
        accounts[i].status === 'ACTIVE' &&
        accounts[i].accountCategory === 'RPSAccountSummary' &&
        accounts[i].century === true
      ) {
        isRPStrac = true;
      }
      if (
        accounts[i].status === 'ACTIVE' &&
        (accounts[i].accountCategory === 'RPSAccountSummary' || accounts[i].accountCategory === 'TRACAccountSummary')
      ) {
        noOfActivePlans = noOfActivePlans + 1;
        planNumber = accounts[i].planNumber;
      }
      if (
        accounts[i].status === 'ACTIVE' &&
        (accounts[i].displayAccountCategory === 'RPSNQAccountSummary' ||
          accounts[i].displayAccountCategory === 'NonQualAccountSummary' ||
          accounts[i].displayAccountCategory === 'RPSNQTRACAccountSummary')
      ) {
        noOfNQPlans = noOfNQPlans + 1;
      }
      if (
        accounts[i].accountCategory === 'RPSAccountSummary' &&
        accounts[i].status === 'TERMINATE' &&
        accounts[i].century === true
      ) {
        rpsTerminatedCount++;
      }
    }
    if (noOfNQPlans === noOfActivePlans) {
      showCTA = false;
    }
    if (accounts.length === rpsTerminatedCount) {
      this.setState({ rpsTracStatus: true });
    }
  };

  handleIncreaseContributions = () => {
    const { hideModal } = this.props;
    hideModal();

    if (noOfActivePlans === 1) {
      if (isRPStrac) {
        window.location.href =
          getDomain() + '/rps/rws/account/participant/trac-iframe-partic-contribs.otc?fromParam=transactions';
      } else {
        window.location.href =
          getDomain() + '/workplace/en/participant/change-contributions.html?planNumber=' + planNumber;
      }
    } else {
      window.location.href = getDomain() + '/rps/rws/account/participant/transactions.otc';
    }
  };

  handleModalContributionChange = () => {
    const { hideModal, showInputTilePopover } = this.props;
    hideModal();
    showInputTilePopover('YourContribution');
    scroller.scrollTo('strategy-container', {
      duration: 1500,
      delay: 0,
      smooth: 'easeInQuad',
    });
  };

  onlyUnique = (value: any, index: any, self: any) => {
    return self.indexOf(value) === index;
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    const { accounts } = this.props;
    const { rpsTracStatus } = this.state;
    let showIncreaseContribution = false;
    const noOfNQPlans: any = [];
    const noOfTRPPlans: any = [];
    let showCTA = true;
    let termedCount = 0;

    if (accounts) {
      accounts.forEach((acc: any, i: any) => {
        if (acc.onlineContribEligible) {
          showIncreaseContribution = true;
        }
        if (
          acc.displayAccountCategory === 'RPSNQAccountSummary' ||
          acc.displayAccountCategory === 'NonQualAccountSummary' ||
          acc.displayAccountCategory === 'RPSNQTRACAccountSummary'
        ) {
          noOfNQPlans.push(accounts[i].planNumber);
        }
        if (acc.accountCategory !== 'Manual') {
          noOfTRPPlans.push(accounts[i].planNumber);
        }

        if (acc.status === 'TERMINATED') {
          termedCount++;
        }
      });
      if (noOfNQPlans.filter(this.onlyUnique).length === noOfTRPPlans.filter(this.onlyUnique).length || rpsTracStatus) {
        showCTA = false;
      } else {
        showCTA = true;
      }

      // Checking if all NQ plans are TERMINATED
      if (termedCount === accounts.length - noOfNQPlans.length) {
        showCTA = false;
      }
    }

    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Saving a little more can make an impact.'} showClose={true} />
        <ReactModalContent>
          <StyledText id={`increase-contribution-text`}>
            A contribution rate increase is one of the best ways to improve your retirement outlook. Start where you can
            and bump it up every year.
            <br />
            <br />
            <b>Example: The impact of a 2% increase</b>
            <br />
            See the impact of a 2% increase over 20 years for someone earning $50,000/year.
          </StyledText>
          {mq.matches ? (
            <StyledImage
              id={`increase-contribution-img1`}
              alt="Increase Contribution"
              src={`data:image/svg+xml;base64,${tokens.AssetImageIncreaseContributionMobile}`}
            />
          ) : (
            <StyledImage
              id={`increase-contribution-img2`}
              alt="Increase Contribution"
              src={`data:image/svg+xml;base64,${tokens.AssetImageIncreaseContribution}`}
            />
          )}
          <CollapsibleHedge
            id={`increase-contribution-collapse-hedge`}
            title={'Information and Assumptions'}
            bodyCopy={informationAndAssumptionsText}
          />
        </ReactModalContent>
        {showCTA && (
          <ReactModalFooter
            CTAButtonText="Model A Contribution Change"
            handleCTAClick={this.handleModalContributionChange}
            hideCancel={true}
            CTAButtonId={analyticsTracking.RIXActionTileContributionsModel}
          >
            {showIncreaseContribution && (
              <Button
                type="secondary"
                title="Increase Contributions"
                fitContainerWidth={mq.matches ? true : false}
                marginRightPx={mq.matches ? 0 : 16}
                onClick={this.handleIncreaseContributions}
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleIncreaseContributions)}
                id={analyticsTracking.RIXActionTileContributionsIncrease}
              />
            )}
          </ReactModalFooter>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
  navigationOptions: state.educationContainer.navigationOptions,
  accounts: state.riScenario.accounts,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showInputTilePopover: inputTilesActions.showInputTilePopover,
})(IncreaseContribution);
